import React from 'react';
import PrivateFile from '../private/PrivateFile';
import './ContextRail.css';

/**
 * The left rail IS the Private file (design pass 4 P2, built 2026-10-04).
 *
 * WHAT LEFT, AND WHERE IT WENT (P2.3 / P4.3). Until pass 4 the rail carried
 * the Arrive group (Last lesson, Carry-forward, From home), Repertoire and
 * Materials. The Arrive group now renders at the top of the notes column at
 * EVERY width (NotesColumn, `.ld-notescol__context`, no width condition any
 * more), and Repertoire and Materials have lived in the Student drawer at every
 * width since pass 3 B1, so nothing was dropped: the rail was the second copy
 * of each. It is now the one place the teachers' private record lives.
 *
 * The rail still hides under 768 and on Warm-ups between 768 and 1439
 * (ContextRail.css, LessonDashboard.css). Where it is hidden the lesson bar's
 * Private control opens the same PrivateFile in a sheet (index.js), so the
 * file always has a door.
 *
 * `privateFile` is the page-owned props bag (entries from usePrivateNotes,
 * history state, the current user); this component only places it.
 */
const ContextRail = ({ student, privateFile = {} }) => {
	if (!student) {
		return (
			<aside className="ld-rail">
				<p className="ld-rail__unlinked">
					<i className="fa-sharp fa-solid fa-user-slash" aria-hidden="true" />
					Not linked yet. Tap the lesson name in the bar above to find a student.
				</p>
			</aside>
		);
	}

	return (
		<aside className="ld-rail ld-rail--private" id="ld-private-rail">
			<PrivateFile studentId={student.id} variant="rail" {...privateFile} />
		</aside>
	);
};

export default ContextRail;
